// hamburger script

const menuHamburger = document.querySelector('.menuHamburger');
const sidebarMenu = document.querySelector('.sidebarMenu');
const closeSidebar = document.querySelector('.close');

menuHamburger.addEventListener('click', e => {
    sidebarMenu.classList.remove('hide-hamburger');
    menuHamburger.classList.add('hide-hamburger');
});

closeSidebar.addEventListener('click', () => {
    menuHamburger.classList.remove('hide-hamburger');
    sidebarMenu.classList.add('hide-hamburger');
});